import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { isEmpty } from 'lodash'
import {
    COOKIE_TOKEN,
    STORAGE_LNG,
    STORAGE_USER_PROFILE,
    URL_API_PREFIX,
    URL_FILE_PREFIX
} from 'config/const/global'
import {
    METHOD_DELETE,
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
} from 'config/const/api'
import {
    TYPE_ACCOUNT,
    TYPE_PASSWORD,
} from 'config/const/type'
import { delCookie, getCookie } from 'utils/cookies'


// APIs relating to user
const waV1Api = createApi({
    reducerPath: "waV1_user",
    baseQuery: fetchBaseQuery({
        baseUrl: URL_API_PREFIX,
        prepareHeaders: (headers, { getState }) => {
            headers.set('Accept', 'application/vnd.api+json')
            // if (!headers.has('Content-Type')) {
            //     headers.set('Content-Type', 'application/vnd.api+json')
            // }
            const lToken = getCookie(COOKIE_TOKEN)
            if (!isEmpty(lToken) && lToken === getState().global.token) headers.set('authorization', `Bearer ${lToken}`)

            return headers
        },
        responseHandler: (response) => {
            if (response.status == 401) {
                localStorage.removeItem(STORAGE_USER_PROFILE)
                delCookie(COOKIE_TOKEN)
                // window.location.replace('/portal/login')
                window.location.reload()
                return
            }

            return response.json()
        }
    }),
    endpoints: builder => ({
        getOrdersData: builder.query({ // for test
            query() {
                return 'orders.json'
            },
            transformResponse(response, meta, arg) {
                return response
            }
        }),
        formSubmit: builder.mutation({
            query(params) {
                return {
                    url: 'payment_gateway/purchase',
                    method: METHOD_POST,
                    body: {
                        ...params,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        createUser: builder.mutation({
            query(regInfo) {
                return {
                    url: 'user',
                    method: METHOD_POST,
                    body: {
                        ...regInfo,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        updateUser: builder.mutation({
            query(dataToChg) {
                return {
                    url: `user/${dataToChg.id}`,
                    method: METHOD_PUT,
                    body: {
                        [dataToChg.type]: dataToChg.value,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        updateUserProfile: builder.mutation({
            query(dataToChg) {
                return {
                    url: `user/${dataToChg.id}`,
                    method: METHOD_PUT,
                    body: {
                        ...dataToChg.payload,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        delUser: builder.mutation({
            query(uid) {
                return {
                    url: `user/${uid}`,
                    method: METHOD_DELETE,
                }
            }
        }),
        getUserList: builder.mutation({
            query() {
                return {
                    url: 'user/list',
                    method: METHOD_POST,
                    body: {
                        filter: [],
                        limit: -1,
                        page: 1,
                        sort: ["ID.DESC"],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getServiceList: builder.mutation({
            query() {
                return {
                    url: 'service/list',
                    method: METHOD_POST,
                    body: {
                        filter: [],
                        limit: -1,
                        page: 1,
                        sort: ["ID.DESC"],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getCusList: builder.mutation({
            query() {
                return {
                    url: 'stripe/customer/list',
                    method: METHOD_GET,
                    // body: {
                    //     filter: [],
                    //     limit: -1,
                    //     page: 1,
                    //     sort: ["ID.DESC"],
                    //     lang: getCookie(STORAGE_LNG)
                    // }
                }
            }
        }),
        getACus: builder.mutation({
            query(cid) {
                return {
                    url: `stripe/customer/${cid}`,
                    method: METHOD_GET,
                    // body: {
                    //     filter: [],
                    //     limit: -1,
                    //     page: 1,
                    //     sort: ["ID.DESC"],
                    //     lang: getCookie(STORAGE_LNG)
                    // }
                }
            }
        }),
        updateService: builder.mutation({
            query(dataToChg) {
                return {
                    url: `service/${dataToChg.id}`,
                    method: METHOD_PUT,
                    body: {
                        ...dataToChg.payload,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        updateCusBalance: builder.mutation({
            query(dataToChg) {
                return {
                    url: `stripe/customer/${dataToChg?.id}/blance_transcation`,
                    method: METHOD_POST,
                    body: {
                        ...dataToChg.payload,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getUserServiceList: builder.mutation({
            query() {
                return {
                    url: 'user_service/list',
                    method: METHOD_POST,
                    body: {
                        filter: [],
                        limit: -1,
                        page: 1,
                        sort: ["ID.DESC"],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        updateUserServiceList: builder.mutation({
            query(params) {
                return {
                    url: `user_service/${params?.id}`,
                    method: METHOD_PUT,
                    body: {
                        ...params?.payload,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getInvoiceList: builder.mutation({
            query(filter) {
                return {
                    url: 'invoice/list',
                    method: METHOD_POST,
                    body: {
                        filter: filter,
                        limit: -1,
                        page: 1,
                        sort: ["ID.DESC"],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getUInvoiceList: builder.mutation({
            query(filter) {
                return {
                    url: 'user/invoice/list',
                    method: METHOD_POST,
                    body: {
                        filter: filter,
                        limit: -1,
                        page: 1,
                        sort: ["ID.DESC"],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),

        getBalance: builder.query({
            query() {
                return 'user/balance'
            }
        }),
        getInvPdf: builder.mutation({
            query(iid) {
                return `invoice/gen_pdf_url/${iid}`
            }
        }),
        sendRecp: builder.mutation({
            query(params) {
                return {
                    url: `receipt`,
                    method: METHOD_POST,
                    body: {
                        ...params,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        getRecpPdf: builder.mutation({
            query(iid) {
                return `receipt/gen_pdf_url/${iid}`
            }
        }),

        vadded: builder.mutation({
            query(sid) {
                return {
                    url: 'payment_gateway/recharge',
                    method: METHOD_POST,
                    body: {
                        services: [sid],
                        payment_method: 'stripe',
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        uploadFile: builder.mutation({
            query(fileData) {
                return {
                    url: 'upload/image',
                    method: METHOD_POST,
                    body: fileData,
                    // formData: true
                }
            }
        }),
        uploadPdf: builder.mutation({
            query(fileData) {
                return {
                    url: 'upload/pdf',
                    method: METHOD_POST,
                    body: fileData,
                    // formData: true
                }
            }
        }),
        bindUserFile: builder.mutation({
            query(ufdata) {
                return {
                    url: 'user_service_file',
                    method: METHOD_POST,
                    body: ufdata,
                }
            }
        }),

        register: builder.mutation({
            query(regInfo) {
                return {
                    url: 'user/register',
                    method: METHOD_POST,
                    body: {
                        ...regInfo,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),

        forgetPwd: builder.mutation({
            query(email) {
                return {
                    url: 'password/forgot',
                    method: METHOD_POST,
                    body: {
                        email,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        resetPwd: builder.mutation({
            query(resetData) {
                return {
                    url: 'password/reset/request',
                    method: METHOD_POST,
                    body: {
                        ...resetData,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),

        getVcode: builder.mutation({
            query(params) {
                return {
                    url: `send_vcode/email/${params.email}?lang=${params.lng}`,
                    method: METHOD_GET,
                    // body: {
                    //     lang: getCookie(STORAGE_LNG)
                    // }
                }
            }
        }),

        sendEnquiry: builder.mutation({
            query(params) {
                return {
                    url: `enquiry`,
                    method: METHOD_POST,
                    body: {
                        ...params,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        listEnquiry: builder.mutation({
            query() {
                return {
                    url: `enquiry/list`,
                    method: METHOD_POST,
                    body: {
                        "sort": [
                            "ID.ASC"
                        ],
                        "page": 1,
                        "limit": -1,
                        "filter": [],
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        delEnquiry: builder.mutation({
            query(id) {
                return {
                    url: `enquiry/${id}`,
                    method: METHOD_DELETE
                }
            }
        }),
        sendReply: builder.mutation({
            query(params) {
                return {
                    url: `enquiry_reply`,
                    method: METHOD_POST,
                    body: {
                        ...params,
                        lang: getCookie(STORAGE_LNG)
                    }
                }
            }
        }),
        // getFile: builder.mutation({
        //     query(params) {
        //         return {
        //             url: `${URL_FILE_PREFIX}${params}`,
        //             method: METHOD_GET
        //         }
        //     },
        //     transformResponse: (response, meta, arg) => {
        //         console.log('11111111111111111', response, meta, arg)
        //         return response
        //     }
        // }),


        login: builder.mutation({
            /**
             * user login
             * @param {{[TYPE_ACCOUNT='account']: String, [TYPE_PASSWORD = 'password']: String}} loginInfo login's account and password
             * @returns response Promise
             */
            query: (loginInfo) => ({
                url: 'user/login',
                method: METHOD_POST,
                body: {
                    login: loginInfo[TYPE_ACCOUNT],
                    password: loginInfo[TYPE_PASSWORD]
                }
            })
        }),

        /**
         * user logout
         */
        logout: builder.mutation({
            query: () => ({
                url: 'user/logout',
                method: METHOD_POST,
            })
        })
    })
})

export const {
    useGetOrdersDataQuery,
    useFormSubmitMutation,
    useGetBalanceQuery,
    useGetInvPdfMutation,
    useGetRecpPdfMutation,
    useSendRecpMutation,
    useCreateUserMutation,
    useUpdateUserMutation,
    useUpdateCusBalanceMutation,
    useUpdateUserProfileMutation,
    useDelUserMutation,
    useVaddedMutation,
    useGetUserListMutation,
    useGetServiceListMutation,
    useGetCusListMutation,
    useGetACusMutation,
    useUpdateServiceMutation,
    useGetUserServiceListMutation,
    useUpdateUserServiceListMutation,
    useGetUInvoiceListMutation,
    useGetInvoiceListMutation,
    useUploadFileMutation,
    useUploadPdfMutation,
    useBindUserFileMutation,
    useRegisterMutation,
    useForgetPwdMutation,
    useResetPwdMutation,
    useGetVcodeMutation,
    useSendEnquiryMutation,
    useListEnquiryMutation,
    useDelEnquiryMutation,
    useSendReplyMutation,
    // useGetFileMutation,
    useLoginMutation,
    useLogoutMutation
} = waV1Api
export default waV1Api